// extracted by mini-css-extract-plugin
export default {"Invoices":"Invoices_Invoices__b81m7","InvoicesList":"Invoices_InvoicesList__Ba2vy","InvoicesHeader":"Invoices_InvoicesHeader__owhY9"};